import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NzFormTooltipIcon } from 'ng-zorro-antd/form';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { StpRegistrationStorageService } from '../../services/stp-registration-storage.service';



@Component({
  selector: 'app-otp-verification',
  templateUrl: './otp-verification.component.html',
  styleUrls: ['./otp-verification.component.scss'],
})


export class OtpVerificationComponent implements OnInit  {

  
  // otpOld: number = 1;
  // otp:number = 0;
  tempNumber: number = 0;
  isVisible = false;
  validateForm!: FormGroup;
  otpForm!: FormGroup;
  // mobile
  contactNumber!: string;
  // otp
  receivedOtp!: string;
  nzFooterVisible: boolean = false;


  constructor(private fb: FormBuilder,
    private stpRegistrationStorageService: StpRegistrationStorageService,
    private notification: NzNotificationService) { }

  ngOnInit(): void {

    this.validateForm = this.fb.group({
      // phoneNumberPrefix: ['+880'],
      // phoneNumber: [null, [Validators.required]],
      // contactNumberPrefixForContactNo: ['+880'],
      // contactNumberPrefixForContactNumber: ['+880'],

  
      contactNumber: ['',
      [
        Validators.required,
        Validators.maxLength(11),
        Validators.minLength(11),
        Validators.pattern(/^[0-9]*$/),
      ],]
    });

    this.otpForm = this.fb.group({
      otp: ['',
      [
        Validators.required,
        Validators.pattern(/^(?:\01)?(?:\d{5})$/),
      ],]

    })
  }

  showModal(): void {
    this.isVisible = true;
    //  this.nzFooter = false;
    setTimeout(() => {
      this.isVisible = false;
    }, 120000);
    
  }
  
  handleOk(): void {
    // console.log(this.otpOld);
    this.isVisible = false;

  }

  handleCancel(): void {
    // console.log('Button cancel clicked!');
    this.isVisible = false;
  }
  // submit phone
  submitForm(): void {
    // console.log(this.validateForm.get('contactNumber')?.value);
    if (this.validateForm.valid) {
      // console.log('submit', this.validateForm.get('contactNumber')?.value);
    }
    this.tempNumber = this.validateForm.get('contactNumber')?.value;
    this.contactNumber = this.tempNumber.toString();

    this.showModal();
    // this.validateForm.reset();
    this.stpRegistrationStorageService.getOtp(this.contactNumber)
    .subscribe({
      next: (res) => {
        // console.log(res.message);
      },
    })

    // else {
    //   Object.values(this.validateForm.controls).forEach(control => {
    //     if (control.invalid) {
    //       control.markAsDirty();
    //       control.updateValueAndValidity({ onlySelf: true });
    //     }
    //   });
    // }
  }

  submitOtp(): void {
    // console.log(this.otpForm.get('otp')?.value);
    // console.log(this.validateForm.get('contactNumber')?.value);
    this.isVisible = false;
    this.receivedOtp = this.otpForm.get('otp')?.value;
    this.contactNumber = this.validateForm.get('contactNumber')?.value;
    // console.log(this.receivedOtp);

    this.stpRegistrationStorageService
        .getVerifiedOtp(this.receivedOtp, this.contactNumber)
        .subscribe({
          next: (response) => {
            this.notification.success('Success!', response.message);
          },
          error: (error) =>
            this.notification.error(
              'Failed',
              'Sorry for your inconvenience'
            ),
        });
        this.otpForm.reset();
        this.validateForm.reset();
  }

}



